
import { Component, Vue } from "vue-property-decorator";
import { BrowserAuthError, InteractionRequiredAuthError, PublicClientApplication } from "@azure/msal-browser";

@Component({})
export default class Hapi extends Vue {
    msalConfig = {
        auth: {
            clientId: process.env.VUE_APP_HOTMAIL_CLIENT_ID,
            authority: "https://login.microsoftonline.com/common",
            redirectUri: window.location.origin,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: true,
        }
    }
    msalInstance = null;
    accessTokenH;
    events: [] | {};
    mounted() {
        this.msalInstance = new PublicClientApplication(this.msalConfig);
    }
    async loginHotmail() {
        const loginRequest = {
            scopes: ["Calendars.Read", "offline_access", "openid", "profile"],
            prompt: "select_account",
        };
        await this.msalInstance.loginPopup(loginRequest)
            .then(async response => {
                const account = response.account;
                if (account) {
                    console.log("TTT Usuario autenticado:", account);
                    localStorage.setItem('hAccount', JSON.stringify(account));
                }
                this.accessTokenH = await response.accessToken;
                await localStorage.setItem("hapiA", response.accessToken);
            })
            .catch(error => {
                console.log("TTT error loginHotmail ", error);
            });
    }
    async refreshAccessTokenHotmail() {
        console.log("TTT refreshAccessTokenHotmail");

        const storedAccount = localStorage.getItem('hotmailAccount');
        let account;
        if (storedAccount)
            account = JSON.parse(storedAccount);
        else
            account = this.msalInstance.getAllAccounts()[0];

        if (!account) {
            console.log("TTT No hay cuenta");
            return await this.loginHotmail();
        }
        const tokenRequest = {
            account: account,
            scopes: ["Calendars.Read", "offline_access", "openid", "profile"],
            forceRefresh: true,
        };
        await this.msalInstance.acquireTokenSilent(tokenRequest)
            .then(async response => {
                this.accessTokenH = await response.accessToken;
                await localStorage.setItem("hapiA", response.accessToken);
            })
            .catch(async error => {
                if (error instanceof InteractionRequiredAuthError) {
                    console.log("TTT error se requiere interacción. Solicitando inicio de sesión...");
                    await this.loginHotmail();
                }
                if (error instanceof BrowserAuthError && error.errorCode === "no_account_error") {
                    console.log("TTT error no_account_error");
                    await this.loginHotmail();
                } else {
                    console.log("TTT error refreshAccessTokenHotmail", error);
                }
            });
    }
    async fetchCalendarEventsHotmail(accessToken) {
        const headers = {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        }
        const response = await fetch("https://graph.microsoft.com/v1.0/me/events", {
            method: "GET",
            headers: headers
        });
        if (!response.ok) {
            const errorData = await response.json();
            if (errorData.error.code == "InvalidAuthenticationToken")
                this.events = { code: 'InvalidAuthenticationToken' }
            else
                this.events = null;
            return;
        }
        const data = await response.json();
        this.events = data.value;
    }
    async loadHotmail(accessToken) {
        if (accessToken)
            this.accessTokenH = accessToken;
        if (!accessToken) await this.loginHotmail();
        await this.fetchCalendarEventsHotmail(this.accessTokenH);
        if (this.events["code"] == "InvalidAuthenticationToken") {
            await this.refreshAccessTokenHotmail();
            await this.fetchCalendarEventsHotmail(this.accessTokenH);
        }
        return this.events;
    }
    async unloadDataHotmail() {
        this.accessTokenH = null;
        localStorage.removeItem("hapiA");
        localStorage.removeItem("hAccount");
        return true;
    }
}